import React from 'react';
import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import av from '../../../assets/person-circle.svg';
import { authState } from '../../../app/auth/authSlice';
import './styles.scss';

interface RoundedIconProps {
  imageUrl?: string;
  width?: number;
  height?: number;
  classname?: string;
  styles?: React.CSSProperties;
  iconName?: React.ReactNode;
  icon?: React.CSSProperties;
  title?: string;
  onClick?: () => void;
  expanded?: boolean;
}

export function RoundedIcon({
  height,
  width,
  imageUrl,
  classname,
  styles,
  iconName,
  icon,
  title,
  onClick,
  expanded,
}: RoundedIconProps) {
  const { t } = useTranslation();
  const iconStyle = {
    height: `${height}px`, // Convert the height prop to pixels
    width: `${width}px`, // Convert the width prop to pixels
    // boxShadow: `0 0 0 3px #fff, 0 0 0 4px ${boxShadowColor}, 0 2px 5px 4px rgba(0,0,0,.2)`,
    ...styles,
  };
  const classes = classNames('mb-icon rounded-icon-wrapper', classname);
  const Iconoclastic = classNames('mb-icon rounded-icon', classname);
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };
  const { profile } = useSelector(authState);

  if (iconName) {
    return (
      <Tooltip trigger={['click', 'hover']} title={!expanded ? title : ''}>
        <button
          // disabled={profile?.settings?.guided_tour}
          className={classNames(
            `${Iconoclastic}
        text-pink-600 dark:text-[#EB3E8E]`,
            { 'pointer-events-none': profile?.user_settings?.guided_tour }
          )}
          style={iconStyle}
          onClick={handleClick}
        >
          <span style={icon}>{iconName}</span>
        </button>
      </Tooltip>
    );
  }
  return (
    <div>
      <Tooltip title={`${t('profile.tooltip')}`}>
        <img
          className={`${classes} text-pink-600 dark:text-[#EB3E8E]`}
          src={imageUrl}
          style={iconStyle}
          alt="avatar"
          onClick={handleClick}
        />
      </Tooltip>
    </div>
  );
}

RoundedIcon.defaultProps = {
  imageUrl: av,
  // height: 64,
  // width: 64,
  // boxShadowColor: '#999',
};

export default React.memo(RoundedIcon);
